const subcontractor = {
    //namespaced: true,

    state: {
        bids: [],
        citations: [],
        designations: [],
        licenses: [],
        references: [],
        safetyYears: [],
    },

    mutations: {

        setBids(state, bids){
            //SEt ti
            state.bids = bids;
        },

        updateBids(state, bid){
            //We need to check to see if the bid is new, or updated
            for (var i = state.bids.length - 1; i >= 0; i--)
            {
                //If the IDs match, replace it
                if(state.bids[i].bid_id == bid.bid_id)
                {
                    //Splice and reset
                    state.bids.splice(i, 1, bid);

                    //Stop here;
                    return;
                }
            }

            //If it get here, it's a new bid. Push it
            state.bids.push(bid);
        },

        deleteBid(state, bid){
            //We need to check to see if the bid is new, or updated
            for (var i = state.bids.length - 1; i >= 0; i--)
            {
                //If the IDs match, replace it
                if(state.bids[i].bid_id == bid.bid_id)
                {
                    //Splice and reset
                    state.bids.splice(i, 1);

                    //Stop here;
                    return;
                }
            }

            //If it get here, it's a new bid. Push it
            state.bids.push(bid);
        },

        setCitations(state, citations){
            //SEt it
            state.citations = citations;
        },

        updateCitation(state, citation){
            //We need to check to see if the bid is new, or updated
            for (var i = state.citations.length - 1; i >= 0; i--)
            {
                //If the IDs match, replace it
                if(state.citations[i].osha_citation_id == citation.osha_citation_id)
                {
                    //Splice and reset
                    state.citations.splice(i, 1, citation);

                    //Stop here;
                    return;
                }
            }

            //If it get here, it's a new bid. Push it
            state.citations.push(citation);
        },

        deleteCitation(state, citation){
            //Loop
            for (var i = state.citations.length - 1; i >= 0; i--)
            {
                //If the IDs match, replace it
                if(state.citations[i].osha_citation_id == citation.osha_citation_id)
                {
                    //Splice and reset
                    state.citations.splice(i, 1);

                    //Stop here;
                    return;
                }
            }
        },

        setDesignations(state, designations){
            //Set it
            state.designations = designations;
        },

        updateDesignations(state, designation){
            //state.jsa = payload;
            //state.jsa = { ...state.jsa };
            //We need to check to see if the bid is new, or updated
            for (var i = state.designations.length - 1; i >= 0; i--)
            {
                //If the IDs match, replace it
                if(state.designations[i].sub_designation_id == designation.sub_designation_id)
                {
                    //Splice and reset
                    state.designations.splice(i, 1, designation);

                    //Stop here;
                    return;
                }
            }

            //If it get here, it's a new bid. Push it
            state.designations.push(designation);
        },

        updateDesignationsBulk(state, designations){
            for (var j = 0; j < designations.length; j++)
            {
                let designation = designations[j];
                //We need to check to see if the bid is new, or updated
                for (var i = state.designations.length - 1; i >= 0; i--)
                {
                    //If the IDs match, replace it
                    if(state.designations[i].sub_designation_id == designation.sub_designation_id)
                    {
                        //Splice and reset
                        state.designations.splice(i, 1, designation);

                        //Stop here;
                        return;
                    }
                }

                //If it get here, it's a new bid. Push it
                state.designations.push(designation);
            }
        },

        deleteDesignation(state, designation){
            //Loop
            for (var i = state.designations.length - 1; i >= 0; i--)
            {
                //If the IDs match, replace it
                if(state.designations[i].sub_designation_id == designation.sub_designation_id)
                {
                    //Splice and reset
                    state.designations.splice(i, 1);

                    //Stop here;
                    return;
                }
            }
        },

        setLicenses(state, licenses){
            //Set it
            state.licenses = licenses;
        },

        updateLicenses(state, license){
            //state.jsa = payload;
            //state.jsa = { ...state.jsa };
            //We need to check to see if the bid is new, or updated
            for (var i = state.licenses.length - 1; i >= 0; i--)
            {
                //If the IDs match, replace it
                if(state.licenses[i].sub_license_id == license.sub_license_id)
                {
                    //Splice and reset
                    state.licenses.splice(i, 1, license);

                    //Stop here;
                    return;
                }
            }

            //If it get here, it's a new bid. Push it
            state.licenses.push(license);
        },

        deleteLicense(state, license){
            //Loop
            for (var i = state.licenses.length - 1; i >= 0; i--)
            {
                //If the IDs match, replace it
                if(state.licenses[i].sub_license_id == license.sub_license_id)
                {
                    //Splice and reset
                    state.licenses.splice(i, 1);

                    //Stop here;
                    return;
                }
            }
        },

        setSafetyYears(state, years){
            //Set the year
            state.safetyYears = years;
        },

        updateSafetyYear(state, year){
            //state.jsa = payload;
            //state.jsa = { ...state.jsa };
            //We need to check to see if the bid is new, or updated
            for (var i = state.safetyYears.length - 1; i >= 0; i--)
            {
                //If the IDs match, replace it
                if(state.safetyYears[i].sub_osha_year_id == year.sub_osha_year_id)
                {
                    //Splice and reset
                    state.safetyYears.splice(i, 1, year);

                    //Stop here;
                    return;
                }
            }

            //If it get here, it's a new bid. Push it
            state.safetyYears.push(year);
        },

        setReferences(state, refs){
            //Set the value
            state.references = refs;
        },

        updateReferences(state, ref){
            //We need to check to see if the bid is new, or updated
            for (var i = state.references.length - 1; i >= 0; i--)
            {
                //If the IDs match, replace it
                if(state.references[i].sub_reference_id == ref.sub_reference_id)
                {
                    state.references.splice(i, 1, ref);

                    //Stop here;
                    return;
                }
            }

            //If it get here, it's a new bid. Push it
            state.references.push(ref);
        },

        deleteReference(state, ref){
            //We need to check to see if the bid is new, or updated
            for (var i = state.references.length - 1; i >= 0; i--)
            {
                //If the IDs match, replace it
                if(state.references[i].sub_reference_id == ref.sub_reference_id)
                {
                    state.references.splice(i, 1);

                    //Stop here;
                    return;
                }
            }

            //If it get here, it's a new bid. Push it
            state.references.push(ref);
        },
    },

    actions: {

    },
}

export default subcontractor;

